import styled from "styled-components";
import { theme } from "../../../../../../constants/StyledComponents";

export const StyledContainerTooltipBody = styled.div`
  width: 260px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const StyledContainerTooltipSections = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const StyledTooltipSections = styled.div<{ $isComplete?: boolean }>`
  border-radius: 6px;
  justify-content: space-between;
  background-color: ${({ $isComplete }) =>
    $isComplete ? theme.colors.green_2 : theme.colors.yellow_2};
  display: flex;
  align-items: center;
  padding: 5px 10px;

  & > div:first-child {
    display: flex;
    gap: 5px;
  }
`;
